import React from 'react';

import styles from './styles';

interface IProps {
  children: React.ReactNode | string;
  classes?: any;
}

const StepGuide = ({ children, classes }: IProps) => {
  return (
    <div className={classes.container}>
      <div className={classes.circle}></div>
      <p>{children}</p>
    </div>
  );
};

export default React.memo(styles(StepGuide));
